// theme.jsから抽出
// ブログ記事の youtube / vimeo / table をラッパーで囲む
(() => {
	const wrapElements = (elements, wrapperClass) => {
		elements.forEach((el) => {
			if (el.parentElement?.classList.contains(wrapperClass)) return;

			const wrapper = document.createElement('div');
			wrapper.className = wrapperClass;
			el.parentNode?.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		});
	};

	const wrapIframe = (iframes, iframeWrapperClass) => {
		wrapElements(iframes, iframeWrapperClass);
		iframes.forEach((iframe) => {
			// Chrome の戻る操作時の iframe 不具合対策
			iframe.src = iframe.src;
		});
	};

	const run = () => {
		const iframeSelectors =
			'.rte iframe[src*="youtube.com/embed"],' +
			'.rte iframe[src*="player.vimeo"],' +
			'.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
			'.custom__item-inner--html iframe[src*="player.vimeo"]';

		wrapIframe([...document.querySelectorAll(iframeSelectors)], 'video-wrapper');

		const tableSelectors =
			'.rte table,' +
			'.custom__item-inner--html table';

		wrapElements([...document.querySelectorAll(tableSelectors)], 'scrollable-wrapper');
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
})();
